/// <reference path="../../_ext/editors/MFGTransItemGridEditor.ts" />

namespace TabAurous.JobWork {

    import fld = JobWorkItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class JobWorkItemsEditor extends _Ext.MFGTransItemGridEditor<JobWorkItemsRow> {


        protected getColumnsKey() { return "JobWork.JobWorkItems"; }
        protected getDialogType() { return JobWorkItemsDialog; }
        protected getLocalTextPrefix() { return JobWorkItemsRow.localTextPrefix; }
        protected form: JobWorkItemsForm;

        public order: JobWorkForm;

        currentrow;
        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public DeptId: number;
        static type: number;
        private NewLineNo: number;
        private GenSKU = true;
        public TransDate: Date;

        public TotalItems: number;
        statement: string;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true, });
            this.element.find('.itemedit').attr('display', 'none');

        }
        protected createSlickGrid(): Slick.Grid {
            var grid = super.createSlickGrid();
            grid.setSelectionModel(new Slick.RowSelectionModel());
            return grid;
        }

        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);

            var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            Department.referencedFields = [fld.DepartmentId];
            Department.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.DepartmentId, OMS.DepartmentMasterRow.getLookup(), this);
            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            //set selected row line no and BOM selection
            this.slickGrid.setSelectedRows([row]);

            var item = this.itemAt(row);
            this.currentrow = this.itemAt(row);

            MaterialEditorForJobWork.LineNo = item.Line_No;
             MaterialEditorForJobWork.Items = item;

            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);
                        // }

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }

                if (target.hasClass('issue-rm')) {
                    //(this.parentDialog as JobWorkDialog).form.MaterialDetails.setData(item);
                    //(this.parentDialog as JobWorkDialog).IssueRM(item);
                    var Items = [];
                    Items.push(item);
                    this.order.MaterialDetails.setData(Items);
                }
            }

        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = item.Pieces < value ? item.DiamondPieces * value : (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = item.Pieces < value ? item.DiamondWeight * value : (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = item.Pieces < value ? item.DiamondAmount * value : (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = item.Pieces < value ? item.StonePieces * value : (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = item.Pieces < value ? item.StoneWeight * value : (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = item.Pieces < value ? item.StoneAmount * value : (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = item.Pieces < value ? item.OtherPieces * value : (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = item.Pieces < value ? item.OtherWeight * value : (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = item.Pieces < value ? item.OtherAmount * value : (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion

        setMasterValues() {
            this.RateListId = (this.parentDialog as JobWorkDialog).RateListId;
            this.LaborListId = (this.parentDialog as JobWorkDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as JobWorkDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as JobWorkDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as JobWorkDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as JobWorkDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as JobWorkDialog).ExchangeRate;
        }

        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Designs",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {
                    let grid;
                    grid = Common.ProductSelectGrid;

                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                            FilterItems: TabAurous.ItemSelection.JMS
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        var self = this;
                        var orddetails = []; 
                        var rateListId = this.RateListId; 
                        var newLineNo = this.NewLineNo;
                        var deptId = this.DeptId;
                        var companyId = Q.Authorization.userDefinition.CompanyId;

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (Item: OMS.ProductMasterRow) {
                            var PrdId = Item.ProductId; 
                            var bomdetails = []; 
                            Purchase.PurchaseMasterService.GetLineNo({}, response => newLineNo = response.Line_No,
                                {
                                    async: false
                                }
                            );
                             

                            // #region Rate, Tax , SKU & Labor 
                            var Rate = 0;
                            var LaborRate = 0;
                             
                            var SKU = "";
                            // #endregion 

                            var purity = 0;
                            var pureweight = 0;
                            if (Item.HasBom) {

                                Item.BOMDetails.forEach(function (BOM) {
                                    //Get Product Details
                                    var BOMPrdDetails = BOM;
                                    var PrdCode = BOMPrdDetails.ProductCode;
                                    var BomAtbId = BOMPrdDetails.BOMAttributeId;

                                    //Get ProductBOM Attributes
                                    var BOMPrdATB = BOM;
                                    if (BOM.ItemType == "METAL") {
                                        var karat = BOMPrdATB.KaratId;
                                        var MetalColor = BOMPrdATB.MetalColorId;
                                        var StdPurity = BOMPrdDetails.Purity;
                                        var ItemTypeId = BOMPrdATB.ItemTypeId;
                                        var BOMRate = GetItemRateHelper.GetGetMetalRate(BOMPrdATB.SubCategoryId);


                                        // *** Rate Calculation ***
                                        //Get Rate from Pricelist or Standard Rate to Calculate BOM Amount and add it to Item Rate
                                        var Amount = BOM.CalcOnId == 3 ? BOM.Pieces * BOMRate : BOM.Weight * StdPurity * BOMRate;
                                        Rate += Amount;
                                        // *** End Rate Calculation ***

                                        var JobWorkBOM: JobWorkBOMRow = {
                                            ProductId: PrdId,
                                            ProductCode: PrdCode,
                                            BOMProductId: BOM.BOMProductId,
                                            BOMAttributeId: BomAtbId,
                                            BomRate: BOMRate,
                                            BomAmount: Amount,
                                            CalcOnId: BOM.CalcOnId,
                                            CalcOn: BOM.CalcOn,
                                            Pieces: BOM.Pieces,
                                            Weight: BOM.Weight,
                                            ItemTypeId: BOM.ItemTypeId,
                                            ItemType: BOM.ItemType,
                                            KaratId: karat,
                                            MetalColorId: MetalColor,
                                            Purity: StdPurity,
                                            Attribute: BOM.Attribute,
                                            CategoryId: BOM.CategoryId,
                                            SubCategoryId: BOM.SubCategoryId,
                                            CategoryName: BOM.CategoryCode,
                                            SubCategoryName: BOM.SubCategoryCode,
                                        }
                                        bomdetails.push(JobWorkBOM);
                                    }
                                    else if (BOM.ItemType == "STONE") {

                                        var Shape = BOMPrdATB.ShapeId;
                                        var Size = BOMPrdATB.StoneSizeId;
                                        var ItemTypeId = BOMPrdATB.ItemTypeId;
                                        var Quality = BOMPrdATB.QualityId;
                                        var StoneColor = BOMPrdATB.StoneColorId;

                                        //Get Rate from Pricelist or Standard Rate to Calculate BOM Amount and add it to Item Rate
                                        let BOMRate = GetItemRateHelper.GetPurchaseRate(BomAtbId, rateListId);
                                        var Amount = BOM.CalcOnId == 3 ? BOM.Pieces * BOMRate : BOM.Weight * BOMRate;
                                        Rate += Amount;
                                        var JobWorkBOM: JobWorkBOMRow = {
                                            ProductId: PrdId,
                                            ProductCode: PrdCode,
                                            BOMProductId: BOM.BOMProductId,
                                            BOMAttributeId: BomAtbId,
                                            BomRate: BOMRate,
                                            BomAmount: Amount,
                                            CalcOn: BOM.CalcOn,
                                            CalcOnId: BOM.CalcOnId,
                                            Pieces: BOM.Pieces,
                                            Weight: BOM.Weight,
                                            ItemType: BOM.ItemType,
                                            ItemTypeId: ItemTypeId,
                                            ShapeId: Shape,
                                            StoneColorId: StoneColor,
                                            QualityId: Quality,
                                            Attribute: BOM.Attribute,
                                            CategoryId: BOM.CategoryId,
                                            SubCategoryId: BOM.SubCategoryId,
                                            CategoryName: BOM.CategoryCode,
                                            SubCategoryName: BOM.SubCategoryCode,

                                        }
                                        bomdetails.push(JobWorkBOM);
                                    }
                                });

                            } else {
                                purity = Item.Purity;
                                pureweight = Item.Weight * purity;
                            }

                            // #endregion

                            //Calculate Tax Amount
                            //var TAmount = ((Rate + LaborRate) * ItemTax[1]) / 100;

                            var purchase: JobWorkItemsRow = {
                                ProductId: Item.ProductId,
                                AttributeId: Item.AttributeId,
                                Line_No: newLineNo,
                                PartyId: self.PartyId,
                                SKU: SKU,
                                DepartmentId: deptId,
                                ProductCode: Item.ProductCode,
                                ProductName: Item.ProductName,
                                ItemTypeId: Item.ItemTypeId,
                                CategoryId: Item.CategoryId,
                                ProductTypeId: Item.ProductTypeId,
                                SubCategoryId: Item.SubCategoryId,
                                BrandId: Item.BrandId,
                                SuperTypeId: Item.SuperTypeId,
                                CollectionId: Item.CollectionId,
                                UnitRate: Rate,
                                UnitLabour: LaborRate,
                                Pieces: 1,
                                Weight: Item.Weight,
                                OtherPieces: Item.OtherPieces,
                                OtherWeight: Item.OtherWeight,
                                StonePieces: Item.StonePieces,
                                StoneWeight: Item.StoneWeight,
                                NetWeight: Item.NetWeight,
                                NetAmount: (Rate + LaborRate) * 1,
                                GrossAmount: (Rate + LaborRate) * 1,
                                DiamondPieces: Item.DiamondPieces,
                                DiamondWeight: Item.DiamondWeight,
                                CalcOnId: Item.CalcOnId,
                                BOMDetails: bomdetails,
                                //   LaborDetails: labordetail,
                                CompanyId: companyId,
                                HSN: Item.HSN,
                                Purity: purity,
                                PureWeight: pureweight,
                                HasBom: Item.HasBom,
                                TaxCode: Item.TaxCode
                            };
                            orddetails.push(purchase);

                        });

                        if (this.view.getItems().length > 0) {
                            self.TotalItems = orddetails.length + this.view.getItems().length;
                        }
                        else {
                            self.TotalItems = orddetails.length;
                        }
                        for (let orderDetail of orddetails) {
                            orderDetail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = orderDetail;
                            this.view.addItem(orderDetail);
                        }
                        //new JobWorkDialog().setData(orddetails);
                    }
                    // #endregion

                    pickerDialog.dialogOpen();

                }
            });
            buttons.push({
                title: "Select Sales Order",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {
                    let grid;
                    grid = Common.OrderItemsSelectGrid;

                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId)
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetLocationTransferItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);
                        this.setData(ItemDetails);

                         
             
                    }
                    // #endregion

                    pickerDialog.dialogOpen();

                }
            });
            buttons.push({
                title: "Select POS Order",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {
                    let grid;
                    grid = Retail.OrderForPurchaseGrid;
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {

                        var filters: _Ext.SelectGridFilters = {
                            PartyId: this.PartyId,
                            InStock: false
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        var self = this;
                        var orddetails = [];
                        var JobWorkLabor = [];
                        var genSKU = this.GenSKU;
                        var rateListId = this.RateListId; 
                        var newLineNo = this.NewLineNo;
                        var deptId = this.DeptId;
                        var companyId = Q.Authorization.userDefinition.CompanyId;

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value) {
                            var PrdId = value.ProductId;
                            var AtbId = value.AttributeId;
                            var bomdetails = []; 
                            var PrdDetails = value;
                            if (value.Line_No == null || value.Line_No == 0 || value.Line_No == null)
                                Purchase.PurchaseMasterService.GetLineNo({}, response => newLineNo = response.Line_No, {
                                    async: false
                                });
                             

                            // #region Rate, Tax , SKU & Labor 
                            var Rate = 0;
                            var LaborRate = 0;

                            // **** Get SKU for Item ****
                            if (genSKU == true) {
                                var SKU = FormatHelper.GetFormat("Sku", "HO");
                            }
                            // #endregion

                            // #region ProductBOM

                            // **** Get and Set Product BOM ****
                            var purity = 0;
                            var pureweight = 0;
                            if (value.HasBom) {


                                value.BOMDetails.forEach(function (value) {
                                    //Get Product Details
                                    var BOMPrdDetails = value;
                                    var PrdCode = BOMPrdDetails.ProductCode;
                                    var BomAtbId = BOMPrdDetails.AttributeId;

                                    //Get ProductBOM Attributes
                                    var BOMPrdATB = value;
                                    if (value.ItemType == "METAL") {
                                        var karat = BOMPrdATB.KaratId;
                                        var MetalColor = BOMPrdATB.MetalColorId;
                                        var StdPurity = BOMPrdDetails.Purity;
                                        var ItemTypeId = BOMPrdATB.ItemTypeId;
                                        var BOMRate = GetItemRateHelper.GetGetMetalRate(BOMPrdATB.SubCategoryId);


                                        // *** Rate Calculation ***
                                        //Get Rate from Pricelist or Standard Rate to Calculate BOM Amount and add it to Item Rate
                                        var Amount = value.CalculateOn == 3 ? value.Pieces * BOMRate : value.Weight * StdPurity * BOMRate;
                                        Rate += Amount;
                                        // *** End Rate Calculation ***

                                        var JobWorkBOM: JobWorkBOMRow = {
                                            ProductId: PrdId,
                                            ProductCode: PrdCode,
                                            BOMProductId: value.BOMProductId,
                                            BOMAttributeId: BomAtbId,
                                            BomRate: BOMRate,
                                            BomAmount: Amount,
                                            Remarks: value.Remarks,
                                            CalcOn: value.CalculateOn,
                                            Pieces: value.Pieces,
                                            Weight: value.Weight,
                                            ItemTypeId: ItemTypeId,
                                            ItemType: value.ItemType,
                                            KaratId: karat,
                                            MetalColorId: MetalColor,
                                            Purity: StdPurity,
                                            Attribute: value.Attribute,
                                            CertificateNo: value.CertificateNo
                                        }
                                        bomdetails.push(JobWorkBOM);
                                    }
                                    else if (value.ItemType == "STONE") {

                                        var Shape = BOMPrdATB.ShapeId;
                                        var Size = BOMPrdATB.StoneSizeId;
                                        var ItemTypeId = BOMPrdATB.ItemTypeId;
                                        var Quality = BOMPrdATB.QualityId;
                                        var StoneColor = BOMPrdATB.StoneColorId;

                                        //Get Rate from Pricelist or Standard Rate to Calculate BOM Amount and add it to Item Rate
                                        let BOMRate = GetItemRateHelper.GetPurchaseRate(BomAtbId, rateListId);
                                        var Amount = value.CalculateOn == 3 ? value.Pieces * BOMRate : value.Weight * BOMRate;
                                        Rate += Amount;

                                        var JobWorkBOM: JobWorkBOMRow = {
                                            ProductId: PrdId,
                                            ProductCode: PrdCode,
                                            BOMProductId: value.BOMProductId,
                                            BOMAttributeId: BomAtbId,
                                            BomRate: BOMRate,
                                            BomAmount: Amount,
                                            Remarks: value.Remarks,
                                            CalcOn: value.CalculateOn,
                                            Pieces: value.Pieces,
                                            Weight: value.Weight,
                                            ItemType: value.ItemType,
                                            ItemTypeId: ItemTypeId,
                                            ShapeId: Shape,
                                            StoneColorId: StoneColor,
                                            QualityId: Quality,
                                            Attribute: value.Attribute,
                                            CertificateNo: value.CertificateNo
                                        }
                                        bomdetails.push(JobWorkBOM);
                                    }
                                });
                            } else {
                                purity = value.Purity;
                                pureweight = value.Weight * purity;
                            }

                            // #endregion

                            //Calculate Tax Amount
                            //var TAmount = ((Rate + LaborRate) * ItemTax[1]) / 100;

                            var purchase: JobWorkItemsRow = {
                                ProductId: PrdId,
                                AttributeId: AtbId,
                                Line_No: newLineNo,
                                PartyId: self.PartyId,
                                SKU: SKU,
                                DepartmentId: deptId,
                                ProductCode: value.ProductCode,
                                ProductName: value.ProductName,
                                ItemTypeId: value.ItemTypeId,
                                CategoryId: value.CategoryId,
                                ProductTypeId: value.ProductTypeId,
                                SubCategoryId: value.SubCategoryId,
                                BrandId: value.BrandId,
                                SuperTypeId: value.SuperTypeId,
                                CollectionId: value.CollectionId,
                                UnitRate: Rate,
                                UnitLabour: LaborRate,
                                Pieces: 1,
                                Weight: value.Weight,
                                OtherPieces: value.OtherPieces,
                                OtherWeight: value.OtherWeight,
                                StonePieces: value.StonePieces,
                                StoneWeight: value.StoneWeight,
                                NetWeight: value.NetWeight,
                                NetAmount: (Rate + LaborRate) * 1,
                                GrossAmount: (Rate + LaborRate) * 1,
                                DiamondPieces: value.DiamondPieces,
                                DiamondWeight: value.DiamondWeight,
                                CalcOnId: value.CalcOnId,
                                BOMDetails: bomdetails,
                                //   LaborDetails: labordetail,
                                CompanyId: companyId,
                                HSN: value.HSN,
                                Purity: purity,
                                PureWeight: pureweight,
                                HasBom: value.HasBom,
                                TaxCode: PrdDetails.TaxCode

                            };
                            orddetails.push(purchase);

                        });
                         
                        for (let orderDetail of orddetails) {
                            orderDetail[this.getIdProperty()] = "`" + this.nextId++; 
                            this.view.addItem(orderDetail);
                        }
                        //new JobWorkDialog().setData(orddetails);
                    }
                    // #endregion

                    pickerDialog.dialogOpen();

                }
            });
            buttons.push({
                title: "Select Rejection In",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {
                    let grid;
                    grid = Inventory.RejectionItemsSelectGrid;

                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId)
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        var self = this;
                        var orddetails = [];
                        var JobWorkLabor = [];
                        var genSKU = this.GenSKU;
                        var rateListId = this.RateListId; 
                        var deptId = this.DeptId;
                        var companyId = Q.Authorization.userDefinition.CompanyId;

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value) {
                            var PrdId = value.ProductId;
                            var AtbId = value.AttributeId;
                            var bomdetails = []; 
                            var PrdDetails = value;

                           

                            // #region Rate, Tax , SKU & Labor 
                            var Rate = 0;
                            var LaborRate = 0;
 
                            // #region ProductBOM

                            // **** Get and Set Product BOM ****
                            var purity = 0;
                            var pureweight = 0;
                            if (value.HasBom) {


                                value.BOMDetails.forEach(function (value) {
                                    //Get Product Details
                                    var BOMPrdDetails = value;
                                    var PrdCode = BOMPrdDetails.ProductCode;
                                    var BomAtbId = BOMPrdDetails.AttributeId;

                                    //Get ProductBOM Attributes
                                    var BOMPrdATB = value;
                                    if (value.ItemType == "METAL") {
                                        var karat = BOMPrdATB.KaratId;
                                        var MetalColor = BOMPrdATB.MetalColorId;
                                        var StdPurity = BOMPrdDetails.Purity;
                                        var ItemTypeId = BOMPrdATB.ItemTypeId;
                                        var BOMRate = GetItemRateHelper.GetGetMetalRate(BOMPrdATB.SubCategoryId);


                                        // *** Rate Calculation ***
                                        //Get Rate from Pricelist or Standard Rate to Calculate BOM Amount and add it to Item Rate
                                        var Amount = value.CalculateOn == 3 ? value.Pieces * BOMRate : value.Weight * StdPurity * BOMRate;
                                        Rate += Amount;
                                        // *** End Rate Calculation ***

                                        var JobWorkBOM: JobWorkBOMRow = {
                                            ProductId: PrdId,
                                            ProductCode: PrdCode,
                                            BOMProductId: value.BOMProductId,
                                            BOMAttributeId: BomAtbId,
                                            BomRate: BOMRate,
                                            BomAmount: Amount,
                                            Remarks: value.Remarks,
                                            CalcOn: value.CalcOn,
                                            Pieces: value.Pieces,
                                            Weight: value.Weight,
                                            ItemTypeId: ItemTypeId,
                                            ItemType: value.ItemType,
                                            KaratId: karat,
                                            MetalColorId: MetalColor,
                                            Purity: StdPurity,
                                            Attribute: value.Attribute,
                                            CertificateNo: value.CertificateNo
                                        }
                                        bomdetails.push(JobWorkBOM);
                                    }
                                    else if (value.ItemType == "STONE") {

                                        var Shape = BOMPrdATB.ShapeId;
                                        var Size = BOMPrdATB.StoneSizeId;
                                        var ItemTypeId = BOMPrdATB.ItemTypeId;
                                        var Quality = BOMPrdATB.QualityId;
                                        var StoneColor = BOMPrdATB.StoneColorId;

                                        //Get Rate from Pricelist or Standard Rate to Calculate BOM Amount and add it to Item Rate
                                        let BOMRate = GetItemRateHelper.GetPurchaseRate(BomAtbId, rateListId);
                                        var Amount = value.CalculateOn == 3 ? value.Pieces * BOMRate : value.Weight * BOMRate;
                                        Rate += Amount;

                                        var JobWorkBOM: JobWorkBOMRow = {
                                            ProductId: PrdId,
                                            ProductCode: PrdCode,
                                            BOMProductId: value.BOMProductId,
                                            BOMAttributeId: BomAtbId,
                                            BomRate: BOMRate,
                                            BomAmount: Amount,
                                            Remarks: value.Remarks,
                                            CalcOn: value.CalcOn,
                                            Pieces: value.Pieces,
                                            Weight: value.Weight,
                                            ItemType: value.ItemType,
                                            ItemTypeId: ItemTypeId,
                                            ShapeId: Shape,
                                            StoneColorId: StoneColor,
                                            QualityId: Quality,
                                            Attribute: value.Attribute,
                                            CertificateNo: value.CertificateNo
                                        }
                                        bomdetails.push(JobWorkBOM);
                                    }
                                });
                            } else {
                                purity = value.Purity;
                                pureweight = value.Weight * purity;
                            }


                            // #endregion

                            //Calculate Tax Amount
                            //var TAmount = ((Rate + LaborRate) * ItemTax[1]) / 100;

                            var purchase: JobWorkItemsRow = {
                                ProductId: PrdId,
                                AttributeId: AtbId,
                                Line_No: value.Line_No == null ? value.LineNo : value.Line_No,
                                PartyId: self.PartyId,
                                SKU: value.SKU == undefined ? value.Sku : value.SKU,
                                DepartmentId: deptId,
                                ProductCode: value.ProductCode,
                                ProductName: value.ProductName,
                                ItemTypeId: value.ItemTypeId,
                                CategoryId: value.CategoryId,
                                ProductTypeId: value.ProductTypeId,
                                SubCategoryId: value.SubCategoryId,
                                BrandId: value.BrandId,
                                SuperTypeId: value.SuperTypeId,
                                CollectionId: value.CollectionId,
                                UnitRate: Rate,
                                UnitLabour: LaborRate,
                                Pieces: value.Pieces,
                                Weight: value.Weight,
                                OtherPieces: value.OtherPieces,
                                OtherWeight: value.OtherWeight,
                                StonePieces: value.StonePieces,
                                StoneWeight: value.StoneWeight,
                                NetWeight: value.NetWeight,
                                NetAmount: (Rate + LaborRate) * 1,
                                GrossAmount: (Rate + LaborRate) * 1,
                                DiamondPieces: value.DiamondPieces,
                                DiamondWeight: value.DiamondWeight,
                                CalcOnId: value.CalcOnId,
                                BOMDetails: bomdetails,
                                //   LaborDetails: labordetail,
                                CompanyId: companyId,
                                HSN: value.HSN == undefined ? value.HSN : value.HSN,
                                RefTransId: value.TransId,
                                RefTransItemId: value.TransItemId,
                                RefVoucherId: value.VoucherTypeId,
                                TaxCode: PrdDetails.TaxCode,
                                BagNo: value.BagNo,
                                BagStatus: value.BagStatus,
                                CertificateNo: value.CertificateNo,
                                Studded: value.Studded,
                                Purity: purity,
                                PureWeight: pureweight,
                                HasBom: value.HasBom

                            };
                            orddetails.push(purchase);

                        });

                        if (this.view.getItems().length > 0) {
                            self.TotalItems = orddetails.length + this.view.getItems().length;
                        }
                        else {
                            self.TotalItems = orddetails.length;
                        }
                        JobWorkDialog.editorClosed = true;
                        for (let orderDetail of orddetails) {
                            orderDetail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = orderDetail;
                            this.view.addItem(orderDetail);
                        }

                        //new JobWorkDialog().setData(orddetails);
                    }
                    // #endregion

                    pickerDialog.dialogOpen();

                }
            });
            buttons.push({
                title: "Select Work Order",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {
                    let grid;
                    grid = Common.WorkOrderStockJWSelectGrid;

                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {

                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var self = this;
                        var details = [];

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: Production.WorkOrderItemsRow) {
                            var PrdId = value.ProductId;
                            var AtbId = value.AttributeId;
                            var bomdetails = [];
                            var labordetail = [];
                            var PrdDetails =value;
                            var atbDetails = value;

                            for (var i = 0; i < value.BOMDetails.length; i++) {
                                var bomvalue = value.BOMDetails[i];
                                var BOMPrdDetails = bomvalue;
                                var BOMAtbDetails = bomvalue;
                                var bom: JobWorkBOMRow = {
                                    BOMAttributeId: bomvalue.AttributeId,
                                    ItemTypeId: bomvalue.ItemTypeId,
                                    RefTransBomId: bomvalue.TransBomId,
                                    Pieces: bomvalue.Pieces,
                                    Weight: bomvalue.Weight,
                                    PureWeight: bomvalue.PureWeight,
                                    Purity: bomvalue.Purity,
                                    BOMProductId: bomvalue.BomProductId,
                                    ProductId: bomvalue.ProductId,
                                    ProductCode: BOMPrdDetails.ProductCode,
                                    ProductName: BOMPrdDetails.ProductName,
                                    CalcOnId: BOMPrdDetails.CalcOnId,
                                    ItemType: BOMAtbDetails.ItemType,
                                    KaratId: BOMAtbDetails.KaratId,
                                    MetalColorId: BOMAtbDetails.MetalColorId,
                                    QualityId: BOMAtbDetails.QualityId,
                                    ShapeId: BOMAtbDetails.ShapeId,
                                    SieveId: BOMAtbDetails.SieveId,
                                    StoneSizeId: BOMAtbDetails.StoneSizeId,
                                    ProductTypeId: BOMAtbDetails.ProductTypeId,
                                    SubCategoryId: BOMAtbDetails.SubCategoryId,
                                    CategoryId: BOMAtbDetails.CategoryId,
                                    Attribute: BOMAtbDetails.Attribute,
                                    StoneColorId: BOMAtbDetails.StoneColorId,
                                    
                                }
                                bomdetails.push(bom);
                            }

                            var item: JobWorkItemsRow = {
                                ProductId: PrdId,
                                AttributeId: AtbId,
                                Line_No: value.Line_No,
                                PartyId: value.POSCustomerId,
                                DepartmentId: value.DepartmentId,
                                ProductCode: value.ProductCode,
                                ProductName: PrdDetails.ProductName,
                                ItemTypeId: atbDetails.ItemTypeId,
                                CategoryId: atbDetails.CategoryId,
                                ProductTypeId: atbDetails.ProductTypeId,
                                SubCategoryId: atbDetails.SubCategoryId,
                                BrandId: atbDetails.BrandId,
                                SuperTypeId: atbDetails.SuperTypeId,
                                CollectionId: atbDetails.CollectionId,
                                Pieces: value.Pieces,
                                Weight: value.Weight,
                                OtherPieces: value.OtherPieces,
                                OtherWeight: value.OtherWeight,
                                StonePieces: value.StonePieces,
                                StoneWeight: value.StoneWeight,
                                NetWeight: value.NetWeight,
                                DiamondPieces: value.DiamondPieces,
                                DiamondWeight: value.DiamondWeight,
                                CalcOnId: PrdDetails.CalcOnId,
                                BOMDetails:bomdetails,
                                //   LaborDetails: labordetail,
                                HSN: PrdDetails.HSN,
                                
                                RefTransId: value.TransId,
                                RefTransItemId: value.TransItemId,
                                RefVoucherId: 65,
                                TaxCode: PrdDetails.TaxCode,
                                BagNo: value.BagNo,
                                Purity: value.Purity,
                                PureWeight: value.PureWeight,
                                HasBom: PrdDetails.HasBom

                            };
                            details.push(item);

                        });

                        //if (this.view.getItems().length > 0) {
                        //    self.TotalItems = details.length + this.view.getItems().length;
                        //}
                        //else {
                        //    self.TotalItems = details.length;
                        //}
                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Detail);
                        }

                        // #endregion

                        
                    }
                    
                    pickerDialog.dialogOpen();

                }
            });


            //var btnAdd = Q.first(buttons, x => x.cssClass == "add-button");

            //btnAdd.onClick = e => { this.addButtonClick(); };

            return buttons;
        }

// #region Set Data

setData(ItemDetails: any[]) {
    if (this.view.getItems().length > 0) {
        this.TotalItems = ItemDetails.length + this.view.getItems().length;
    }
    else {
        this.TotalItems = ItemDetails.length;
    }
    for (let Itemdetail of ItemDetails) {
        Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
        this.view.addItem(Itemdetail);
    }
}

        // #endregion
    }
}